import type { AccountantStatusSummaryEntity } from "../entities/AccountantStatusEntity";
import type { AccountantStatusRepository } from "../repositories/AccountantStatusRepository";

export class GetAccountantStatusSummaryUseCase {
  constructor(private readonly repository: AccountantStatusRepository) {}

  async execute(params: {
    year?: number;
    month?: number;
    period?: "last_month" | "last_3_months";
  }): Promise<AccountantStatusSummaryEntity> {
    return this.repository.getSummary(params);
  }
}
